import { Col, Row, Space, Spin } from "antd";
import React, { useState } from "react";
import AutomationsCard from "../components/AutomationsCard/AutomationsCard";
import DateRangePicker from "../components/DateRangePicker/DateRangePicker";

// eslint-disable-next-line import/extensions
import DiscordActiveMembersCard from "../components/DiscordActiveMembersCard/DiscordActiveMembersCard";
// eslint-disable-next-line import/extensions
import DiscordMostActiveChannelsCard from "../components/DiscordMostActiveChannelsCard/DiscordMostActiveChannelsCard";
// eslint-disable-next-line import/extensions
import DiscordMostActiveMembersCard from "../components/DiscordMostActiveMembersCard/DiscordMostActiveMembersCard";
// eslint-disable-next-line import/extensions
import EngagementCard from "../components/EngagementCard/EngagementCard";
import TopPosts from "../components/InsightsPage/TopPosts";
import NewMembersCard from "../components/NewMembersCard/NewMembersCard";
import Paywall from "../components/Paywall/Paywall";
import { usePaywallStateDispatch } from "../components/Paywall/PaywallContext";

const DiscordHome = () => {
  const guildId = localStorage.getItem("guild-id");

  // Card expansion triggers
  const [expandActiveMembers, setExpandActiveMembers] =
    useState<boolean>(false);
  const [expandNewMembers, setExpandNewMembers] = useState<boolean>(false);
  const { loadingPlanTier, userPlanTier } = usePaywallStateDispatch();

  return (
    <div>
      <Spin spinning={false}>
        <Row style={{ paddingBottom: 40 }}>
          <Col span={8} />
          <Col span={8} offset={8} style={{ textAlign: "end" }}>
            <Space>
              <Paywall
                free={
                  <DateRangePicker
                    customOption={{
                      disabled: true,
                      warningMsg: "This is restricted to Business users",
                    }}
                  />
                }
                pro={
                  <DateRangePicker
                    rangeOfSelector={{
                      range: "day",
                      selectorDefaultOptions: [
                        { value: 7, disabled: false },
                        {
                          value: 30,
                          disabled: false,
                        },
                      ],
                    }}
                    customOption={{
                      disabled: true,
                      warningMsg: "This is restricted to Business users",
                    }}
                  />
                }
                business={
                  <DateRangePicker
                    customOption={{ disabled: false }}
                    rangeOfSelector={{
                      range: "day",
                      selectorDefaultOptions: [
                        { value: 7, disabled: false },
                        {
                          value: 30,
                          disabled: false,
                        },
                      ],
                    }}
                  />
                }
                tier={userPlanTier}
                loading={loadingPlanTier}
              />
            </Space>
          </Col>
        </Row>
        <Row gutter={[32, 32]} style={{ marginBottom: 50 }}>
          <Col span={12} className="automations-widget">
            <AutomationsCard />
          </Col>
          <Col span={12}>
            <EngagementCard teamId={guildId} span={12} url="/insights" />
          </Col>
          <Col lg={expandActiveMembers ? 24 : 12} md={24}>
            <DiscordActiveMembersCard
              guildId={guildId}
              span={24}
              expandActiveMembers={expandActiveMembers}
              setExpandActiveMembers={setExpandActiveMembers}
            />
          </Col>
          <Col span={12}>
            <DiscordMostActiveMembersCard guildId={guildId} />
          </Col>
          <Col span={12}>
            <DiscordMostActiveChannelsCard guildId={guildId} />
          </Col>
          <Col lg={expandNewMembers ? 24 : 12} md={24}>
            <NewMembersCard
              span={12}
              expandNewMembers={expandNewMembers}
              setExpandNewMembers={setExpandNewMembers}
            />
          </Col>
          <Col span={12}>
            <TopPosts
              platform="discord"
              // startTime={startTime}
              // endTime={endTime}
            />
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

export default DiscordHome;
